<form action="#" class="search-bar d-flex mr-0">
  <input [value]="(term$ | async).searhTerm"
  [class.amazon-provider]="(provider$ | async) == 1"
  [class.shein-provider]="(provider$ | async) == 2"
  [class.walmart-provider]="(provider$ | async) == 3"
  [class.homedepot-provider]="(provider$ | async) == 4"
  [class.bestbuy-provider]="(provider$ | async) == 5"
  [formControl]="searhControl" type="text" name="search-bar" id="search-id" autocomplete="on" placeholder="Buscar...">
  <!-- [disabled]="searhControl.value.length==0" -->
  <div id="show-amazon" class="search-cat"
  [class.amazon-provider]="(provider$ | async) == 1"
  [class.shein-provider]="(provider$ | async) == 2"
  [class.walmart-provider]="(provider$ | async) == 3"
  [class.homedepot-provider]="(provider$ | async) == 4"
  [class.bestbuy-provider]="(provider$ | async) == 5">

    <div ngbDropdown class="position-relative d-flex justify-content-center align-items-center w-100 h-100"
      style="cursor: pointer;">

      <div class="pt-1" id="dropdownConfig" ngbDropdownToggle>
        <img *ngIf="(provider$ | async)==0" width="80px" src="assets/js/xemart/msdropdown/cubatel.png" />
        <img *ngIf="(provider$ | async)==1 && turnOnAmazon" width="65px" src="assets/js/xemart/msdropdown/amazon.png" />
        <img *ngIf="(provider$ | async)==2 && turnOnShein" width="65px" src="assets/js/xemart/msdropdown/shein.png" />
        <img *ngIf="(provider$ | async)==3 && turnOnWalmart" width="75px" src="assets/js/xemart/msdropdown/walmart.png" />
        <img *ngIf="(provider$ | async)==4 && turnOnHomeDepot" width="85px" style="margin: 10px 5px 15px 0px;" src="assets/js/xemart/msdropdown/icon_homedepot.svg" />
        <img *ngIf="(provider$ | async)==5 && turnOnBestBuy" width="75px" style="margin: 10px 5px 15px 0px;" src="assets/js/xemart/msdropdown/icon_bestbuy.svg" />
      </div>

      <!--<span class="caret"></span>-->
      <div class="py-0" ngbDropdownMenu aria-labelledby="dropdownConfig">
        <span class="pl-3 py-2" (click)="setProvider(0)" ngbDropdownItem><img width="80px"
            src="assets/js/xemart/msdropdown/cubatel.png" /></span>

        <span *ngIf="turnOnAmazon" class="py-2" style="border-top: 1px solid #ebebeb!important; padding-left: 1.3rem"
          (click)="setProvider(1)" ngbDropdownItem><img width="65px"
            src="assets/js/xemart/msdropdown/amazon.png" /></span>

          <span *ngIf="turnOnShein" class="py-2" style="border-top: 1px solid #ebebeb!important; padding-left: 1.3rem"
            (click)="setProvider(2)" ngbDropdownItem><img width="65px"
              src="assets/js/xemart/msdropdown/shein.png" /></span>

              <span *ngIf="turnOnWalmart" class="py-2" style="border-top: 1px solid #ebebeb!important; padding-left: 1.3rem"
              (click)="setProvider(3)" ngbDropdownItem><img width="85px"
                src="assets/js/xemart/msdropdown/walmart.png" /></span>

                <span *ngIf="turnOnHomeDepot" class="py-2" style="border-top: 1px solid #ebebeb!important; padding-left: 1.3rem"
                (click)="setProvider(4)" ngbDropdownItem><img width="85px"
                  src="assets/js/xemart/msdropdown/icon_homedepot.svg" /></span>

                  <span *ngIf="turnOnBestBuy" class="py-2" style="border-top: 1px solid #ebebeb!important; padding-left: 1.3rem"
                  (click)="setProvider(5)" ngbDropdownItem><img width="85px"
                    src="assets/js/xemart/msdropdown/icon_bestbuy.svg" /></span>

      </div>
    </div>

  </div>

  <div *ngIf="stop"
    class="position-absolute d-flex justify-content-center align-items-center dropdown-toggle amazon-css">
    <div *ngIf="((provider$ | async) == 3 || (provider | async) == 3) && turnOnWalmart" class="pt-1"><img width="85px" src="assets/js/xemart/msdropdown/walmart.png" /></div>
    <div *ngIf="((provider$ | async) == 1 || (provider | async) == 1) && turnOnAmazon" class="pt-1"><img width="65px" src="assets/js/xemart/msdropdown/amazon.png" /></div>
    <div *ngIf="((provider$ | async) == 2 || (provider | async) == 2) && turnOnShein" class="pt-1"><img width="65px" src="assets/js/xemart/msdropdown/shein.png" /></div>
    <div *ngIf="((provider$ | async) == 4 || (provider | async) == 4) && turnOnHomeDepot" class="pt-1"><img width="85px" src="assets/js/xemart/msdropdown/icon_homedepot.svg" /></div>
    <div *ngIf="((provider$ | async) == 5 || (provider | async) == 5) && turnOnBestBuy" class="pt-1"><img width="75px" src="assets/js/xemart/msdropdown/icon_bestbuy.svg" /></div>
  </div>

  <button class="btnSearch"
     [class.amazon-provider]="(provider$ | async) == 1 && turnOnAmazon"
     [class.shein-provider]="(provider$ | async) == 2 && turnOnShein"
     [class.walmart-provider]="(provider$ | async) == 3 && turnOnWalmart"
     [class.homedepot-provider]="(provider$ | async) == 4 && turnOnHomeDepot"
     [class.bestbuy-provider]="(provider$ | async) == 5 && turnOnBestBuy"
     type="button" (click)="search()">
    <i class="fa fa-search"></i>
  </button>
</form>
